import { apiRequest, API_URL, getAuthToken } from "./api";

export const storyService = {
  // Get all published stories
  getPublishedStories: async () => {
    return await apiRequest("/stories", {
      method: "GET",
      requiresAuth: false,
    });
  },

  // Get all stories (admin only)
  getAllStories: async () => {
    return await apiRequest("/stories/admin/all", {
      method: "GET",
      requiresAuth: true,
    });
  },

  // Get single story by ID
  getStory: async (id) => {
    return await apiRequest(`/stories/${id}`, {
      method: "GET",
      requiresAuth: false,
    });
  },

  // Upload a story image file, returns { imageUrl }
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    const response = await fetch(`${API_URL}/stories/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getAuthToken() || ""}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || "Failed to upload image");
    }

    return await response.json();
  },

  // Create story (admin only)
  createStory: async (title, description, imageUrl, isPublished = true) => {
    return await apiRequest("/stories", {
      method: "POST",
      requiresAuth: true,
      body: JSON.stringify({
        title,
        description,
        imageUrl,
        isPublished,
      }),
    });
  },

  // Update story (admin only)
  updateStory: async (id, updates) => {
    return await apiRequest(`/stories/${id}`, {
      method: "PUT",
      requiresAuth: true,
      body: JSON.stringify(updates),
    });
  },

  // Delete story (admin only)
  deleteStory: async (id) => {
    return await apiRequest(`/stories/${id}`, {
      method: "DELETE",
      requiresAuth: true,
    });
  },
};
